import {
  WayPurchaseActiveSubscriptionDisplayVm,
  WayPurchaseNotificationData,
} from '../models/way-purchase.models';
import { formatWayPurchaseChannel } from './way-purchase-channel.util';
import {
  formatActiveSubscriptionLastWashedDate,
  formatTotalWashesAvailable,
  formatWashesRedeemed,
  pickString,
  readPurchase,
  readRecord,
  resolveLicensePlate,
} from './way-purchase-display.helpers';

export function buildWayPurchaseActiveSubscriptionDisplayVm(
  data: WayPurchaseNotificationData | Record<string, any> | null | undefined
): WayPurchaseActiveSubscriptionDisplayVm | null {
  const row = readRecord(data);
  const purchase = readPurchase(row);
  if (!purchase) {
    return null;
  }

  const purchaseType = String(purchase.purchase_type ?? '').trim().toLowerCase();
  if (purchaseType !== 'membership') {
    return null;
  }

  return {
    customerName: pickString(purchase.customer_name) || '—',
    licensePlate: resolveLicensePlate(row, purchase),
    packageName: pickString(purchase.package_name) || '—',
    totalWashesAvailableDisplay: formatTotalWashesAvailable(purchase.washes_included),
    totalWashesRedeemedDisplay: formatWashesRedeemed(purchase.washes_redeemed),
    lastWashedDateDisplay: formatActiveSubscriptionLastWashedDate(purchase.last_washed_at),
    statusLabel: 'Subscription Active',
    channelLabel: formatWayPurchaseChannel(purchase.purchase_channel),
  };
}
